import { useId, useState, useMemo, Fragment } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup } from '@ui/kit';
import { ContinueArrowIcon } from '@ui/kit/icons';
import { sequenceTileInput } from '@utils/component-framework';
import { SizeTransition } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useTaskContext } from '../../../context.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { root, toggle, scroller, transitionWrapper, crossfadeDurationMs, wrapper, circuit, tokens, item, getPointOnCircle } from './container.facit.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CircuitFacitContainer(props) {
  const context = useTaskContext();
  const id = useId();
  const [tab, setTab] = useState("answer");
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  const amountOfItems = userOrderedInputs.length * 2;
  return /*#__PURE__*/jsxs("div", {
    className: root,
    children: [context === "facit" && /*#__PURE__*/jsx(ToggleGroup, {
      className: toggle,
      baseId: id,
      label: "V\xE6lg visningstilstand",
      onTabClick: setTab,
      selectedTabId: tab,
      tabs: [{
        id: "answer",
        title: "Mit svar"
      }, {
        id: "facit",
        title: "Rigtigt svar"
      }]
    }), /*#__PURE__*/jsx("div", {
      className: scroller,
      "data-tab": tab,
      children: /*#__PURE__*/jsxs(TransitionGroup, {
        component: "div",
        className: transitionWrapper,
        children: [tab === "answer" && /*#__PURE__*/jsx(SizeTransition, {
          axis: "vertical",
          swappable: true,
          classNames: wrapper,
          timeout: crossfadeDurationMs,
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            id: `${id}-panel-answer`,
            className: wrapper,
            "data-theme": "input",
            children: /*#__PURE__*/jsx("div", {
              className: circuit,
              children: userOrderedInputs.map((input, index) => /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx("div", {
                  className: item,
                  style: tokens.__override({
                    offset: index * 2 / amountOfItems,
                    pointX: getPointOnCircle(index * 2 / amountOfItems).x,
                    pointY: getPointOnCircle(index * 2 / amountOfItems).y
                  }),
                  children: /*#__PURE__*/jsx(SequenceInput, {
                    node: input,
                    taskEntryKey: props.taskEntryKey
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: item,
                  style: tokens.__override({
                    offset: (index * 2 + 1) / amountOfItems,
                    pointX: getPointOnCircle((index * 2 + 1) / amountOfItems).x,
                    pointY: getPointOnCircle((index * 2 + 1) / amountOfItems).y
                  }),
                  children: /*#__PURE__*/jsx(ContinueArrowIcon, {
                    height: 20
                  })
                })]
              }, input.id))
            })
          })
        }, "answer"), tab === "facit" && /*#__PURE__*/jsx(SizeTransition, {
          axis: "vertical",
          swappable: true,
          classNames: wrapper,
          timeout: crossfadeDurationMs,
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            id: `${id}-panel-facit`,
            className: wrapper,
            "data-theme": "facit",
            children: /*#__PURE__*/jsx("div", {
              className: circuit,
              children: props.task.content.map((input, index) => /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx("div", {
                  className: item,
                  style: tokens.__override({
                    offset: index * 2 / amountOfItems,
                    pointX: getPointOnCircle(index * 2 / amountOfItems).x,
                    pointY: getPointOnCircle(index * 2 / amountOfItems).y
                  }),
                  children: /*#__PURE__*/jsx(SequenceInput, {
                    node: input,
                    taskEntryKey: props.taskEntryKey,
                    facitType: "should-have"
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: item,
                  style: tokens.__override({
                    offset: (index * 2 + 1) / amountOfItems,
                    pointX: getPointOnCircle((index * 2 + 1) / amountOfItems).x,
                    pointY: getPointOnCircle((index * 2 + 1) / amountOfItems).y
                  }),
                  children: /*#__PURE__*/jsx(ContinueArrowIcon, {
                    height: 20
                  })
                })]
              }, input.id))
            })
          })
        }, "facit")]
      })
    })]
  });
}

export { CircuitFacitContainer };
//# sourceMappingURL=container.facit.js.map
